import { useMemo } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import qs from 'query-string';

const useQueryString = ({ preserveState = false } = {}) => {
  const history = useHistory();
  const { search, pathname, state, hash } = useLocation();
  const onChange = (newValue, isReplaceHistory = false) => {
    history[isReplaceHistory ? 'replace' : 'push']({
      pathname,
      search: qs.stringify(newValue),
      ...(preserveState ? { state, hash } : {}),
    });
  };

  const value = useMemo(() => qs.parse(search), [search]);

  return [value, onChange];
};

export default useQueryString;
